export function watch(notification) {
    return {
        type: 'NOTIFICATIONS_WATCH_EXPIRATION',
        notification
    };
}
